import React from "react";

export const MapSection = () => {
  return (
    <section className="w-full">
      <div className="w-full h-[450px] lg:h-[500px]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.2306468277716!2d72.8348389!3d19.1413786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7302008e789%3A0xa2df7a4190afb664!2sBarry%20John&#39;s%20Free%20Birds%20%7C%20The%20Free%20Birds%20Collective!5e0!3m2!1sen!2sin!4v1766746909179!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="The Free Birds Collective Location"
        />
      </div>
    </section>
  );
};
